import * as PIXI from 'pixi.js'

class Updater {
  constructor (game) {
    this.game = game
    this.ticker = new PIXI.ticker.Ticker()
    this.isPaused = false
  }

  start () {
    this.ticker.start()
  }

  nextTick (callback) {
    this.ticker.add(callback)
  }

  play (callback) {
    this.isPaused = false
    this.ticker.start()

    if (callback) {
      callback()
    }
  }

  pause (callback) {
    this.isPaused = true
    this.ticker.stop()

    if (callback) {
      callback()
    }
  }

  destroy () {
    this.ticker.destroy()
  }
}

export default Updater
